import { countriesActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case countriesActionTypes.SET_COUNTRIES:
            return action.countries;
        case countriesActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};